<template>
  <v-footer
        :active.sync="activeBtn"
        :value="showNav"
        fixed                
      
        app
      >

        <v-btn active-class="navActive" round center depressed flat style="width: 33vw !important; border-radius: 50px;  " @click="$router.replace('/')">
    
           <v-icon round center size="24" style="margin-top: 6px;">mdi-home</v-icon>

        </v-btn>   

      <v-btn active-class="navActive" round center depressed flat style="width: 33vw !important; margin-top: 1px; border-radius: 50px;"  @click="$router.replace('/subs')">
          
         <!-- <v-icon size="28" >search</v-icon>-->

         <!-- <img center v-if="$route.path === '/browse'" src="./assets/images/search-white.png" style="height:22px;"/> -->
         <v-icon round center size="29" style="margin-top: 6px;">mdi-playlist-star </v-icon>
         <!--<img center src="./assets/images/search.png" style="height:22px;"/>-->
      </v-btn>

      <v-btn active-class="navActive" round center depressed flat  style="margin-top: 3px;width: 33vw !important;border-radius: 50px; " @click="$router.replace('/playlist')">
       
          <!--<v-icon size="28">mdi-account-outline</v-icon>-->
         <!-- <img center src="../assets/images/user.png" style="height:23px;"/> -->
         <v-icon round center size="29" style="margin-top: 6px;">mdi-view-list</v-icon>
         <!-- user-white.png v-if="$route.path === '/user'"  <img center v-else src="./assets/images/user.png" style="height:22px;"/>-->

        </v-btn>
       <!-- <v-btn active-class="navActive" round center depressed flat  style="margin-top: 3px;width: 33vw !important;border-radius: 50px; " @click="$router.replace('cube')">
            <v-icon round center size="29" style="margin-top: 6px;">mdi-bell</v-icon>
        </v-btn>-->
  </v-footer>

</template>

<script>
export default {
  name: "Footer",
  data: () => ({
    activeBtn: 0,
    showNav: true,
  }),
};


</script>
